import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/lib/legalData";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" slug="/privacy">
      <p className="lead">
        La presente informativa è resa ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (di seguito, "<b>GDPR</b>") e del D.Lgs. 196/2003 (Codice Privacy), come modificato dal D.Lgs. 101/2018, a tutti coloro (di seguito gli "<b>Interessati</b>") che interagiscono con la piattaforma <b>{COMPANY.brand}</b> (di seguito, la "<b>Piattaforma</b>"), accessibile all'indirizzo <a href={COMPANY.app_url}>{COMPANY.app_url}</a>.
      </p>

      <h2>1. Titolare del Trattamento</h2>
      <p>
        Il Titolare del Trattamento dei dati personali è <b>{COMPANY.legal_name}</b>, con sede legale in {COMPANY.legal_address.full}, P.IVA {COMPANY.vat_number}, C.F. {COMPANY.fiscal_code}, REA {COMPANY.rea_number}, in persona del legale rappresentante pro tempore.
      </p>
      <ul>
        <li><b>PEC:</b> <a href={`mailto:${COMPANY.pec}`}>{COMPANY.pec}</a></li>
        <li><b>Email:</b> <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
        <li><b>Email Privacy:</b> <a href={`mailto:${COMPANY.privacy_email}`}>{COMPANY.privacy_email}</a></li>
        <li><b>Telefono:</b> <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}>{COMPANY.phone}</a></li>
      </ul>

      <div style={{padding: "16px", background: "#FFF8E1", borderLeft: "4px solid #F77F2A", borderRadius: "8px", margin: "16px 0"}}>
        <p style={{margin: 0}}>
          <b>Importante — Doppio ruolo nel rapporto con il Consulente.</b> Quando i dati personali sono raccolti
          tramite una pagina brandizzata di un consulente/agenzia (URL del tipo gostreet.it/c/...), il
          <b> Titolare del Trattamento è il Consulente/Agenzia</b> che eroga il servizio al Cliente finale,
          mentre <b>{COMPANY.legal_name}</b> opera in qualità di <b>Responsabile esterno del trattamento</b>
          ai sensi dell&apos;art. 28 GDPR, sulla base di Data Processing Agreement firmato. Le finalità del
          trattamento sono determinate dal Consulente; {COMPANY.legal_name} si limita all&apos;ospitalità tecnica
          e all&apos;elaborazione dei dati per conto del Consulente. La presente Privacy Policy disciplina invece
          il trattamento di cui {COMPANY.legal_name} è Titolare diretto (dati dei consulenti, dati di
          fatturazione, dati di chi naviga direttamente su gostreet.it senza ID consulente).
        </p>
      </div>

      <p>
        L&apos;elenco aggiornato dei <b>sub-responsabili tecnici</b> (sub-processor) utilizzati da {COMPANY.legal_name}
        è pubblicato sulla pagina <a href="/sub-processors">/sub-processors</a> ed è aggiornato ogni volta che
        ne viene introdotto uno nuovo.
      </p>

      <h2>2. Responsabile della Protezione dei Dati (DPO)</h2>
      <p>
        Considerate le dimensioni e l'attività del Titolare, non sussiste l'obbligo di nomina di un DPO ai sensi dell'art. 37 del GDPR. Per qualunque richiesta in materia di protezione dati, l'Interessato può rivolgersi al Titolare ai recapiti sopra indicati.
      </p>

      <h2>3. Categorie di dati trattati</h2>
      <p>La Piattaforma tratta le seguenti categorie di dati personali:</p>
      <h3>3.1 Dati dei Clienti (automobilisti)</h3>
      <ul>
        <li>Dati anagrafici: nome, cognome</li>
        <li>Dati di contatto: email, numero di telefono</li>
        <li>Dati del veicolo: targa</li>
        <li>Dati di localizzazione (GPS): latitudine e longitudine al momento della segnalazione del sinistro</li>
        <li>Contenuti multimediali allegati alle pratiche: fotografie, video, registrazioni audio del luogo del sinistro</li>
        <li>Dati di sinistro: descrizione testuale fornita dall'Interessato</li>
        <li>Dati di autenticazione/firma: codice OTP a 6 cifre (mai conservato in chiaro), token di conferma email</li>
        <li>Metadati tecnici: indirizzo IP, user-agent, data e ora delle interazioni</li>
      </ul>

      <h3>3.2 Dati dei Consulenti</h3>
      <ul>
        <li>Dati anagrafici e professionali: nome studio, descrizione attività</li>
        <li>Dati di contatto: email, telefono</li>
        <li>Credenziali di accesso (password cifrata con algoritmo bcrypt)</li>
        <li>Dati di configurazione: logo, colori brand, numeri convenzionati</li>
      </ul>

      <h2>4. Finalità e basi giuridiche del trattamento</h2>
      <table>
        <thead>
          <tr><th>Finalità</th><th>Base giuridica</th><th>Periodo conservazione</th></tr>
        </thead>
        <tbody>
          <tr>
            <td>Erogazione del servizio (apertura, gestione, chiusura pratica di sinistro)</td>
            <td>Esecuzione di un contratto / misure precontrattuali · art. 6.1.b GDPR</td>
            <td>Fino a chiusura pratica + 30/60/90 giorni (configurabili dal Consulente per ciascuna pratica)</td>
          </tr>
          <tr>
            <td>Firma elettronica semplice (FES) della pratica via OTP e conferma email, ai sensi del Reg. UE 910/2014 (eIDAS)</td>
            <td>Consenso esplicito dell'Interessato · art. 6.1.a GDPR + Reg. 910/2014</td>
            <td>Come sopra; gli evidence di firma sono conservati per finalità probatorie ex art. 2697 c.c.</td>
          </tr>
          <tr>
            <td>Adempimento di obblighi di legge (contabili, fiscali, antiriciclaggio ove applicabile)</td>
            <td>Obbligo di legge · art. 6.1.c GDPR</td>
            <td>10 anni (art. 2220 c.c.)</td>
          </tr>
          <tr>
            <td>Sicurezza informatica della Piattaforma (log accessi, prevenzione abusi)</td>
            <td>Legittimo interesse del Titolare · art. 6.1.f GDPR</td>
            <td>12 mesi</td>
          </tr>
          <tr>
            <td>Comunicazioni di servizio dal Consulente verso il Cliente (su consenso facoltativo dell'Interessato)</td>
            <td>Consenso · art. 6.1.a GDPR — revocabile in qualsiasi momento</td>
            <td>Fino a revoca consenso</td>
          </tr>
        </tbody>
      </table>

      <h2>5. Modalità di trattamento</h2>
      <p>
        I dati personali sono trattati con strumenti elettronici, con logiche strettamente correlate alle finalità sopra indicate e adottando misure di sicurezza adeguate ai sensi dell'art. 32 GDPR, tra cui:
      </p>
      <ul>
        <li>Trasmissione cifrata in HTTPS/TLS 1.3</li>
        <li>Conservazione cifrata at-rest dei file media (fotografie, video, audio)</li>
        <li>Password protette con algoritmo crittografico bcrypt (hashing irreversibile)</li>
        <li>Autenticazione a token JWT con scadenza, controllo del ruolo (consulente / cliente / amministratore)</li>
        <li>Limitazione degli accessi al solo personale autorizzato dal Titolare</li>
        <li>Backup periodici e procedure di disaster recovery</li>
      </ul>

      <h2>6. Destinatari dei dati e Responsabili esterni</h2>
      <p>I dati possono essere comunicati ai seguenti soggetti, nominati Responsabili del Trattamento ex art. 28 GDPR:</p>
      <ul>
        <li><b>Consulente infortunistico</b> destinatario della segnalazione (autonomo Titolare in qualità di gestore della pratica)</li>
        <li><b>Resend Inc.</b> (San Francisco, USA) — servizio email transazionale, con trasferimento garantito da Standard Contractual Clauses UE 2021/914</li>
        <li><b>MongoDB Inc.</b> / Provider hosting — gestione database, server localizzati in UE</li>
        <li><b>Object Storage Provider</b> — archiviazione file media, server in UE</li>
        <li>Consulenti del lavoro, commercialisti, legali dell'Azienda per adempimenti obbligatori</li>
        <li>Autorità giudiziarie e amministrative, ove richiesto da legge o ordine</li>
      </ul>
      <p>L'elenco aggiornato dei Responsabili può essere richiesto a <a href={`mailto:${COMPANY.privacy_email}`}>{COMPANY.privacy_email}</a>.</p>

      <h2>7. Trasferimento dei dati extra-UE</h2>
      <p>
        Alcuni fornitori (ad es. Resend) possono comportare un trasferimento di dati personali al di fuori dello Spazio Economico Europeo. Tali trasferimenti avvengono esclusivamente in presenza di adeguate garanzie ai sensi dell'art. 46 GDPR (Standard Contractual Clauses approvate dalla Commissione Europea con Decisione 2021/914) o di una decisione di adeguatezza ai sensi dell'art. 45 GDPR.
      </p>

      <h2>8. Conferimento dei dati</h2>
      <p>
        Il conferimento dei dati personali necessari all'esecuzione del servizio (nome, cognome, email, telefono, targa, descrizione sinistro) è obbligatorio: un eventuale rifiuto comporta l'impossibilità di erogare il servizio. Il conferimento del consenso al marketing è invece facoltativo.
      </p>

      <h2>9. Diritti dell'Interessato</h2>
      <p>L'Interessato può esercitare in qualsiasi momento i seguenti diritti previsti dagli artt. 15-22 GDPR:</p>
      <ul>
        <li><b>Accesso</b> ai propri dati (art. 15)</li>
        <li><b>Rettifica</b> di dati inesatti o incompleti (art. 16)</li>
        <li><b>Cancellazione</b> ("diritto all'oblio") nei casi previsti dall'art. 17</li>
        <li><b>Limitazione</b> del trattamento (art. 18)</li>
        <li><b>Portabilità</b> dei dati (art. 20)</li>
        <li><b>Opposizione</b> al trattamento basato su legittimo interesse (art. 21)</li>
        <li><b>Revoca</b> del consenso in qualsiasi momento, senza pregiudicare la liceità del trattamento precedente</li>
        <li><b>Reclamo</b> all'Autorità Garante per la Protezione dei Dati Personali (<a href="https://www.gpdp.it" target="_blank" rel="noreferrer">www.gpdp.it</a>)</li>
      </ul>
      <p>
        Per esercitare i diritti scrivere a: <a href={`mailto:${COMPANY.privacy_email}`}>{COMPANY.privacy_email}</a> o PEC <a href={`mailto:${COMPANY.pec}`}>{COMPANY.pec}</a>. Il Titolare risponderà entro <b>30 giorni</b> dalla ricezione della richiesta.
      </p>

      <h2>10. Processo decisionale automatizzato e profilazione</h2>
      <p>
        La Piattaforma <b>non effettua</b> processi decisionali automatizzati né profilazione ai sensi dell'art. 22 GDPR. La gestione delle pratiche è eseguita esclusivamente dal Consulente umano. Si veda anche la <a href="/trasparenza-ai">pagina sulla trasparenza AI Act</a>.
      </p>

      <h2>11. Modifiche alla Privacy Policy</h2>
      <p>
        Il Titolare si riserva di aggiornare la presente informativa per adeguarla a sopravvenute novità normative o operative. La versione aggiornata sarà sempre disponibile su questa pagina con indicazione della data di ultimo aggiornamento.
      </p>
    </LegalLayout>
  );
}
